import { useRef, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PageSkeleton } from './SkeletonLoader.jsx';

function ProtectedRoute({ children, allowedRoles, allowGuest = false }) {
    const { user, loading } = useAuth();
    const hasAlerted = useRef(false);

    useEffect(() => {
        if (!loading && !user && !hasAlerted.current) {
            hasAlerted.current = true;
        }
    }, [loading, user]);

    if (loading) {
        return <PageSkeleton label="Loading your workspace" cards={3} />;
    }

    if (!user && !allowGuest) {
        return <Navigate to="/login" replace />;
    }

    if (user && !user.is_verified && user.role !== 'admin') {
        return <Navigate to="/verify-email" replace />;
    }

    if (user && allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default ProtectedRoute;
